<template>
  <div id="app" :class="`browser-${currentBrowser}`">
    <loading :loading="authLoading">
      <page-template>
        <router-view v-slot="{ Component }">
          <transition name="fade">
            <component :is="Component" />
          </transition>
        </router-view>
      </page-template>
    </loading>
  </div>
</template>

<script lang="js">
import { mapActions, mapGetters, mapState } from 'vuex'
import { path } from 'ramda'
import Loading from './components/Loading'
import PageTemplate from './components/PageTemplate/PageTemplate'
import { currentBrowser } from './utils/browser'

export default {
  name: 'App',
  components: { Loading, PageTemplate },
  data() {
    return { currentBrowser }
  },
  computed: {
    ...mapGetters(
      {
        corePageLoadComplete: 'corePageLoadComplete',
      },
    ),
    ...mapState(
      {
        authLoading: path(['auth', 'loading']),
        isAuthenticated: path(['auth', 'isAuthenticated']),
        notificationLoadComplete: path(['notifications', 'loaded']),
      },
    ),
  },
  created() {
    this.initCookieConsent()
    this.initializeAuth()
  },
  mounted() {
    this.setRedirect()
  },
  updated() {
    this.setRedirect()
  },
  watch: {
    corePageLoadComplete() {
      if (this.corePageLoadComplete) {
        if (!this.notificationLoadComplete && this.isAuthenticated) {
          this.xhrLoadNotifications()
        }
      }
    },
  },
  methods: {
    ...mapActions(
      {
        initializeAuth: 'auth/initialize',
        initCookieConsent: 'cookieConsent/init',
        xhrLoadNotifications: 'notifications/xhrLoad',
      },
    ),
    getShouldRedirect() {
      return this.$router.currentRoute.meta.requiresAuth && !this.authLoading && !this.isAuthenticated
    },
    setRedirect() {
      if (this.getShouldRedirect()) {
        this.$router.replace('/login')
      }
    },
  },
}
</script>

<style lang="scss">
  @import 'assets/scss/app.scss';
</style>
